export class EventReservationSource {
    /**
   * Reservation from file integration with FTP through IVE.
   */
    static readonly FILE = 'FILE';
    /**
     * Manual reservation created by the UI user.
     */
    static readonly MANUAL = 'MANUAL';
    /**
     * Reservation from uploaded spreadsheet.
     */
    static readonly UPLOADED = 'UPLOADED';
    /**
     * Reservation created from an unmatched RSVP.
     */
    static readonly RSVP = 'RSVP';
    /**
     * Out-of-block reservation.
     */
    static readonly OUT_OF_BLOCK = 'OUT_OF_BLOCK';
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-reservation-source.ts